module.exports = __webpack_public_path__ + "site/img/49.fed02ba6.jpg";